module.exports = __webpack_public_path__ + "img/list-view-active.5eaa8620.svg";